// removed by extract-text-webpack-plugin
module.exports = {"linksWrap":"src-components-modules-DevHeader-DevMobileNav-style----general-module---linksWrap---3ln-t bg-white pinAll position-fixed zi-overlay","links":"src-components-modules-DevHeader-DevMobileNav-style----general-module---links---1nEOt paddingLeft-l pinBL position-absolute","nav":"src-components-modules-DevHeader-DevMobileNav-style----general-module---nav---3dHpa cursor-pointer pinTR position-fixed transitionDuration-m zi-overlay"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/DevHeader/DevMobileNav/style/general.module.css
// module id = 1448
// module chunks = 168707334958949